var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.257 6.99994L8.207 11.9499C8.30251 12.0422 8.37869 12.1525 8.4311 12.2745C8.48351 12.3965 8.5111 12.5278 8.51225 12.6605C8.51341 12.7933 8.48811 12.925 8.43782 13.0479C8.38754 13.1708 8.31329 13.2824 8.2194 13.3763C8.1255 13.4702 8.01385 13.5445 7.89096 13.5948C7.76806 13.645 7.63638 13.6703 7.5036 13.6692C7.37082 13.668 7.2396 13.6404 7.1176 13.588C6.99559 13.5356 6.88525 13.4594 6.793 13.3639L1.136 7.70694C0.948531 7.51941 0.843216 7.2651 0.843216 6.99994C0.843216 6.73477 0.948531 6.48046 1.136 6.29294L6.793 0.635936C6.9816 0.453778 7.23421 0.352984 7.4964 0.355262C7.7586 0.357541 8.00941 0.46271 8.19482 0.648118C8.38023 0.833526 8.4854 1.08434 8.48768 1.34654C8.48995 1.60873 8.38916 1.86133 8.207 2.04994L3.257 6.99994Z",
    fill: "#697077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/leftChevron.bbd6772f145f9bcfbf907977c4f9b9d7.svg";
export { ForwardRef as ReactComponent };